/**
 * Like builtin 'Partial<T>', but only for specified keys
 */
export type PartialBy<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;
